import gql from 'graphql-tag';

export const queryForCommercialFacilities = gql`
  query queryForCommercialFacilities(
    $limit: Int!
    $page: Int!
    $query: CommercialFacilitySortOrQuery
    $sort: CommercialFacilitySortOrQuery
  ) {
    queryForCommercialFacilities(
      limit: $limit
      page: $page
      query: $query
      sort: $sort
    ) {
      items {
        id
        facilityName
        facilityId
        company
        facilityType
        aor
        operatingArea
        marketArea
        facilityLineSegment
        rateableTake
        criticalDay
      }
      totalRecords
    }
  }
`;
